<template>
  <div class="container" style="background-color: #fff;">
    <HeaderComponent :menu-id="2"></HeaderComponent>

    <div style="position: relative; width: 100%;">
      <div class="content">
        <!-- 标题 -->
        <div class="title-ty">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>古钱币送评</span>服务内容</div>
        </div>
        <!-- 服务 -->
        <div class="fuwu-top-box">
          <div class="fuwu-top">
            <img class="fuwu-top-img" src="@/assets/image/fuwuneirong-guqian.png" alt="">
            <div class="fuwu-top-1 fuwu-title-ty">基础服务</div>
            <div class="fuwu-top-content">水石评级对送评古钱币，进行真伪鉴定、评级打分、价值评估等评级服务，所有评级钱币信息官网存
              档，有据可查。</div>
          </div>
          <!-- 服务时效 -->
          <div class="shixiao-box">
            <div class="shixiao-title">评级时效：</div>
            <div class="shixiao-list">
              <div class="shixiao-item">
                <img src="@/assets/icon/p-ping.png" alt="">
                <div class="shixiao-item-content">
                  <div class="shixiao-item-content-top">普通评级</div>
                  <div class="shixiao-item-content-bottom">10—15个工作日</div>
                </div>
              </div>
              <div class="shixiao-item">
                <img src="@/assets/icon/k-ping.png" alt="">
                <div class="shixiao-item-content">
                  <div class="shixiao-item-content-top">快速评级</div>
                  <div class="shixiao-item-content-bottom">5个工作日，费用为普评费用的两倍</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 增值服务 -->
        <div class="fuwu-top-box" style="padding: 50px 0;">
          <div class="fuwu-title-ty" style="padding-left: 50px;">增值服务</div>
          <ul class="zengzhi-list">
            <li class="zengzhi-item">
              <img class="zengzhi-item-img" src="@/assets/image/zengzhi-1.png" alt="">
              <div class="zengzhi-item-content">
                <div class="zengzhi-item-title">重新评级</div>
                <div class="zengzhi-item-text">指钱币已由水石评级完成评级，送评人认为该币仍有提升分数空间，再次提交至水石评级进行的
                  复评服务。</div>
              </div>
            </li>
            <li class="zengzhi-item">
              <img class="zengzhi-item-img" src="@/assets/image/zengzhi-2.png" alt="">
              <div class="zengzhi-item-content">
                <div class="zengzhi-item-title">换装评级</div>
                <div class="zengzhi-item-text">指钱币已由其他评级机构鉴定封装，送评人将其提交至水石评级进行重新鉴定评级，并更换为水
                  石评级专属封装盒。</div>
              </div>
            </li>
            <li class="zengzhi-item" style="border: none;">
              <img class="zengzhi-item-img" src="@/assets/image/zengzhi-3.png" alt="">
              <div class="zengzhi-item-content">
                <div class="zengzhi-item-title">重新装盒</div>
                <div class="zengzhi-item-text">对外观出现磨损、损坏的水石评级封装盒进行更换。</div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 售后终身服务 -->
        <div class="fuwu-top-box" style="padding: 50px 0; border: none;">
          <div class="fuwu-title-ty" style="padding-left: 50px;">售后终身服务</div>
          <ul class="shouhou-list">
            <li class="shouhou-item" style="margin-bottom: 50px;">
              <div class="shouhou-item-tag">1</div>
              <img class="shouhou-item-img" style="width: 100px; height: 80px;" src="@/assets/icon/shouhou-1.png"
                alt="">
              <div>水石评级将按照"一币一估值，全额赔付"的核心理念，对送评古钱币的真伪以及修补，做终身售后服务。</div>
            </li>
            <li class="shouhou-item">
              <div class="shouhou-item-tag">2</div>
              <img class="shouhou-item-img" src="@/assets/icon/shouhou-2.png" alt="">
              <div>古钱币售后服务时效，为3个工作日。</div>
            </li>
          </ul>
        </div>
      </div>
      <img src="@/assets/image/logo-shuiyin.png" alt=""
        style="width: 300px; position:absolute; bottom: 0px; left: 0px;" />
    </div>

    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {

    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  width: 1200px;
  margin: 0 auto;
}
</style>